import React, { Component } from 'react';
import Sidebar from 'react-sidebar';

import { TwitchChat } from './TwitchChat';

const mql = window.matchMedia(`(min-width: 1100px)`);

export class ChatSideBar extends Component {

  state = {
    sidebarOpen: false,
    sidebarDocked: false,
  }

  componentWillMount = () => {
    mql.addListener(this.mediaQueryChanged);
    this.setState({ mql: mql, sidebarDocked: mql.matches });
  }

  componentWillUnmount = () => {
    this.state.mql.removeListener(this.mediaQueryChanged);
  }

  mediaQueryChanged = () => {
    this.setState({ sidebarDocked: this.state.mql.matches });
  }

  onSetSidebarOpen = (open) => {
    this.setState({sidebarOpen: open});
  }

  render() {
    return (
      <Sidebar 
        sidebar={<TwitchChat />}
        docked={this.state.sidebarDocked}
        open={this.state.sidebarOpen}
        onSetOpen={this.onSetSidebarOpen}
        styles={{
          sidebar: {
            overflowY: 'hidden',
          },
        }}
        pullRight={true}
      >
        { this.state.sidebarDocked || this.state.sidebarOpen ? null :
            <div style={{
              position: 'absolute',
              top: '10px',
              right: '5px',
              zIndex: '2',
              color: 'white',
              fontSize: '10px',
              cursor: 'pointer',
            }} onClick={this.onSetSidebarOpen}>
              {'<'} CHAT
            </div>
          }
        {this.props.children}
      </Sidebar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatSideBar.js